<template>
  <v-row justify="center">
    <v-dialog :value="dialog" @input="$emit('dialogChange', $event)" persistent max-width="600px">
      <v-card>
        <v-card-title class="primary">
          <span style="color: #fff" class="text-h5">Duplicar Aula Infantil</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(enableSubmit)" :disabled="false">
                <v-row>
                  <v-col class="pt-4 pb-0" cols="12">
                    <e-label class="font-weight-medium">Tipo de Aula</e-label>
                    <p class="font-weight-regular">
                      {{ aulaDuplicada.tipo_de_aula }}
                    </p>
                  </v-col>

                  <!-- <v-col class="pt-0 pb-0" :cols="12" :sm="4">
                    <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
                      <e-label class="font-weight-medium">Data</e-label>
                      <e-date-picker v-model="dataAulaDuplicada" :error-messages="errors" />
                    </ValidationProvider>
                  </v-col> -->

                  <v-col class="pt-0 pb-0" :cols="12" :sm="4">
                    <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
                      <v-dialog
                        ref="dialog_date_picker"
                        v-model="modal"
                        :return-value.sync="date"
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <e-label>Selecione uma data</e-label>
                          <v-text-field
                            dense
                            solo
                            v-model="data"
                            label="data"
                            v-bind="attrs"
                            v-on="on"
                            :error-messages="errors"
                            @change="pesquisaAulas(dataAulaDuplicada, horarioSelecionado.id)"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="primary"
                          v-model="dataAulaDuplicada"
                          scrollable
                          :allowed-dates="datasPermitidas"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
                          <v-btn text color="primary" @click="$refs.dialog_date_picker.save(date)">
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </ValidationProvider>
                  </v-col>

                  <v-col
                    class="pt-0 pb-0"
                    v-if="aulaDuplicada.tipo_de_aula !== 'Aula Remota'"
                    cols="6"
                  >
                    <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
                      <e-label>Selecione um horário</e-label>
                      <e-autocomplete
                        :items="horariosPermitidos"
                        :error-messages="errors"
                        label="Selecione uma opção"
                        :item-text="(item) => item.descricao"
                        v-model="horarioSelecionado"
                        return-object
                        dense
                        @change="pesquisaAulas(dataAulaDuplicada, horarioSelecionado.id)"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row>
                  <!-- {{ aulaDuplicada.campos_de_experiencias }} -->
                  <v-col cols="12">
                    <e-label class="font-weight-medium mb-5">Temas integrados</e-label>
                    <ul>
                      <li
                        v-for="campo_de_experiencia in aulaDuplicada.campos_de_experiencias.filter(
                          (c) => c
                        )"
                        :key="campo_de_experiencia"
                        class="font-weight-regular"
                      >
                        {{ campo_de_experiencia }}
                      </li>
                    </ul>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium mb-5">Temas integrados</e-label>
                    <div
                      class="font-weight-regular"
                      v-html="formatarQuebrasDeLinha(aulaDuplicada.eixos)"
                    ></div>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium">Possibilidades pedagógicas</e-label>
                    <div
                      class="font-weight-regular"
                      v-html="formatarQuebrasDeLinha(aulaDuplicada.estrategias)"
                    ></div>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium">Observações</e-label>
                    <div
                      class="font-weight-regular"
                      v-html="formatarQuebrasDeLinha(aulaDuplicada.observacoes)"
                    ></div>
                  </v-col>
                </v-row>

                <v-divider class="my-6"></v-divider>
                <e-progresso-preenchimento
                  :expectedItems="itemsEsperados"
                  :filledItems="itemsPreenchidos"
                  @total-filled-changed="
                    (value) => $checkTotallyFilled(value, 'totalmentePreenchido')
                  "
                />

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    style="color: #fff"
                    class="red darken-1"
                    @click="
                      $emit('dialogChange', { open: false, wasDuplicated: false });
                      limparCampos();
                    "
                  >
                    Fechar
                  </v-btn>
                  <v-btn
                    style="color: #fff"
                    class="green darken-1"
                    type="submit"
                    :disabled="
                      aulasEmConflitos || submittingForm || faltaPreencher || !totalmentePreenchido
                    "
                  >
                    Salvar
                  </v-btn>
                </v-card-actions>
              </form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="duplicarAula"
    >
    </e-modal-confirm>
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      require: true,
    },
    gestaoDeAula: {
      type: Object,
      require: true,
    },
    // horarios: {
    //   type: Array,
    //   require: true,
    // },
    disciplinas: {
      type: Array,
    },
    aulasEmConflitos: {
      type: Boolean,
      default: false,
    },
    datasPermitidas: {
      type: Function,
    },
  },
  data() {
    return {
      data: null,
      modal: false,
      menu: false,
      date: null,
      aulaDuplicada: {},
      confirmDialog: false,
      dataAulaDuplicada: null,
      objectModal: {
        title: "Duplicar aula",
        message: "Tem certeza que deseja duplicar esta aula?",
      },
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      horariosPermitidos: [],
      itemsEsperados: [
        { label: "Data", value: "dataAulaDuplicada" },
        { label: "Horário", value: "horarioSelecionado" },
      ],
      itemsPreenchidos: [],
      totalmentePreenchido: false,
    };
  },
  computed: {
    faltaPreencher() {
      return !this.data || !this.horarioSelecionado || !this.horarioSelecionado.id;
    },
  },
  created() {
    this.itemsEsperados.forEach((item) => {
      this.$watch(item.value, (val) => {
        this.$toggleItemPreenchidoBarraProgresso(item.value, val, this.itemsPreenchidos);
      });
    });
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        this.aulaDuplicada = val;
      },
    },
    dataAulaDuplicada(value) {
      if (!value) {
        this.data = null;
        return;
      }
      this.filtrarHorariosPorDiaDaSemana(new Date(value).getDay());

      const date = new Date(value);
      if (date.toString() === "Invalid Date") {
        this.data = null;
        return;
      }

      const data_formatada = new Intl.DateTimeFormat("pt-BR", {
        timeZone: "UTC",
      }).format(date);

      this.data = data_formatada;

      if (this.dialog && this.horarioSelecionado?.id) {
        this.pesquisaAulas(value, this.horarioSelecionado.id);
      }
    },
    data(value) {
      // const data_old = new Intl.DateTimeFormat("pt-BR", {
      //   timeZone: "UTC",
      // }).format(new Date(value));
      // this.aulaSelecionada.data = data_old.replaceAll("/", "/");
      // this.filtrarHorariosPorDiaDaSemana(new Date(value).getDay());
    },
  },
  methods: {
    async filtrarHorariosPorDiaDaSemana(diaDaSemana) {
      if (!this.gestaoDeAula.relacoesDiasHorarios) return;
      this.horariosPermitidos = this.gestaoDeAula.relacoesDiasHorarios
        .filter((relacao) => relacao.dia.id === diaDaSemana)
        .map((relacao) => relacao.horario);
    },
    enableSubmit() {
      if (!this.dataAulaDuplicada || !this.horarioSelecionado?.id) {
        this.$toast.danger("Preencha todos os campos obrigatórios: data e horário.");
        return;
      }
      this.confirmDialog = !this.confirmDialog;
      this.aulaDuplicada.data = this.dataAulaDuplicada;
    },
    async duplicarAula() {
      this.$loaderService.open("Duplicando a Aula");
      try {
        this.aulaDuplicada.horario_inicial = this.horarioSelecionado
          ? this.horarioSelecionado.inicio
          : null;
        this.aulaDuplicada.horario_final = this.horarioSelecionado
          ? this.horarioSelecionado.final
          : null;
        this.aulaDuplicada.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
        this.aulaDuplicada.gestao_de_aula = parseInt(this.$route.params.gestaoDeAulaId, 10);
        this.aulaDuplicada.disciplina_id = this.form.disciplina_id;
        this.aulaDuplicada.turma_id = this.form.turma_id;
        this.aulaDuplicada.instrutor_id = this.form.instrutor_id;
        await this.$services.aulasService.criar(this.aulaDuplicada);
        this.confirmDialog = !this.confirmDialog;
        this.$emit("dialogChange", { open: false, wasDuplicated: true });
        this.$toast.success("Aula duplicada com sucesso!");
        this.$router.push({
          name: "aulasInfantis",
          params: { gestaoDeAulaId: this.$route.params.gestaoDeAulaId },
        });
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    pesquisaAulas(aula_data, horario_id) {
      if (!this.dialog) return;

      const payload = {
        data_aula: aula_data,
        horariosIds: [horario_id],
        turma_id: this.gestaoDeAula.turma.id,
      };

      this.$emit("checarConflitos", payload);
    },
    limparCampos() {
      this.dataAulaDuplicada = null;
      this.horarioSelecionado = { descricao: "Escolha um horario" };
    },
    formatarQuebrasDeLinha(texto) {
      return texto ? texto.replace(/\n/g, "<br>") : "";
    },
  },
};
</script>
